import React from 'react';
import LinkWithParams from 'components/LinkWithParams/LinkWithParams';
import { XXL, LG, MD } from '@zendeskgarden/react-typography';
import Flex from 'styled-flex-component';
import { Row, Col } from '@zendeskgarden/react-grid';
import { HeroHeader } from './CompanyWhyUsHero.styles.js';


const CompanyWhyUsHero = (props) => {
 
  return (
      <HeroHeader>
        <div>
          <Row>
            <Col md={12}>
              <div>
                <Flex alignCenter>
                  <MD bold letterSpacing="true" slate uppercase tag="p">Why Magnetic Resonance Technologies</MD>
                </Flex>
                <XXL style={{maxWidth: '1100px'}} bold paddingTopLg navy tag="h1">Proven Engineers, More Experience, Better References.</XXL>
                <LG style={{maxWidth: '1000px'}} paddingTopMd navy light tag="h3">
                  Leading the Industry from <LinkWithParams to="/c/equipment">Procurement</LinkWithParams> to <LinkWithParams to="/services/ongoing-services">Maintenance Programs</LinkWithParams> MRT is the team that vendors and doctors alike turn to when they are facing obstacles and needing solutions. Cut out the middle-man and go straight to the talent.
                </LG>

                <LG style={{maxWidth: '1000px'}} paddingTopMd navy light tag="h3">
                  We provide total turn-key solutions including <LinkWithParams to="/services/pre-install-planning">Consulting</LinkWithParams>, <LinkWithParams to="/services">MRI Shielding</LinkWithParams>, and <LinkWithParams to="/services/ongoing-services">Equipment Service</LinkWithParams> all accomplished by in-house, highly trained, and experienced specialists.
                </LG>

                <LG style={{maxWidth: '1000px'}} paddingTopMd navy light tag="h3" bold>
                  We’ll gladly put our knowledge, products and personnel up against anyone in the business. We do things right the first time and we aren’t satisfied until we’ve exceeded your expectations.
                </LG>
              </div>

            </Col>
          </Row>
        </div>
      </HeroHeader>

  )
}


export default CompanyWhyUsHero;
